import React from 'react';
import './FieldPreview.css';

/**
 * Схема поля: гексагональная сетка, жетоны и стартовые флаги (см.
 * buildFieldPreviewModel). Без Phaser — таких схем на странице выбора много.
 *
 * @param {Object|null} model — модель схемы; пока ее нет, остается пустое место
 * @param {string} [title] — подпись для экранного диктора; внутри кнопки с
 *   названием поля не нужна
 * @param {boolean} [isUnitSizeShown] — числа на нейтральных отрядах: читаются
 *   только на крупной схеме
 * @param {string} [className]
 */
const FieldPreview = React.memo(({model, title, isUnitSizeShown = false, className = ''}) => {
  if (!model) {
    return <span className={`field-preview field-preview_empty ${className}`}/>;
  }

  const {viewBox: {x, y, width, height}, hexSize, gridPath, layers, units} = model;

  return (
    <svg
      className={`field-preview ${className}`}
      viewBox={`${x} ${y} ${width} ${height}`}
      preserveAspectRatio="xMidYMid meet"
      role={title ? 'img' : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
    >
      <path className="field-preview_grid" d={gridPath} data-layer="grid"/>
      {layers.map(({id, fill, fillOpacity, cellPath, markPath, markFill, polePath}) => (
        <g key={id} data-layer={id}>
          <path d={cellPath} fill={fill} fillOpacity={fillOpacity} data-part="cell"/>
          {polePath && <path className="field-preview_pole" d={polePath} data-part="pole"/>}
          {markPath && (
            <path
              className={polePath ? 'field-preview_cloth' : undefined} d={markPath} fill={markFill} data-part="mark"
            />
          )}
        </g>
      ))}
      {units.map(({id, x: unitX, y: unitY, size}) => (
        <g key={id} data-layer="unit">
          <circle className="field-preview_unit" cx={unitX} cy={unitY} r={hexSize * 0.5}/>
          {isUnitSizeShown && (
            <text className="field-preview_unit-size" x={unitX} y={unitY} fontSize={hexSize * 0.62}>
              {size}
            </text>
          )}
        </g>
      ))}
    </svg>
  );
});

export default FieldPreview;
